import { useQuery } from 'react-query';

import { getWidgetData as queryFn } from 'api/endPoints/getWidgetData';
import { QueryKeys } from 'api/queryKeys';

import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

export const useQueryGetMatrixData = (params: QueryParams, endpoint?: string) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['useQueryGetMatrixData', params],
        queryFn: () => queryFn(params, endpoint),
        enabled: Boolean(params.metaDataId) && Boolean(params.numOfDaysToBeUrgent),
    });
};

export interface QueryParams {
    metaDataId: number | undefined;
    numOfDaysToBeUrgent: number | null;
    filter: { filters: IFilter[] };
}

export interface QueryResponse {
    doNowComponent: {
        title: string;
        itemRecommendation: {
            title: string;
            matrixItemIndex: number;
            numOfItem: number;
            numOfOverdue: number;
            numOfDelayDriver: number;
            numOfCriticalPath: number;
            numOfAssignedToMe: number;
        };
        itemUserActivities: {
            title: string;
            matrixItemIndex: number;
            numOfItem: number;
            numOfOverdue: number;
            numOfDelayDriver: number;
            numOfCriticalPath: number;
            numOfAssignedToMe: number;
        };
        itemProgramActivities: {
            title: string;
            matrixItemIndex: number;
            numOfItem: number;
            numOfOverdue: number;
            numOfDelayDriver: number;
            numOfCriticalPath: number;
            numOfAssignedToMe: number;
        };
    };
    doNextComponent: {
        title: string;
        itemRecommendation: {
            title: string;
            matrixItemIndex: number;
            numOfItem: number;
            numOfOverdue: number;
            numOfDelayDriver: number;
            numOfCriticalPath: number;
            numOfAssignedToMe: number;
        };
        itemUserActivities: {
            title: string;
            matrixItemIndex: number;
            numOfItem: number;
            numOfOverdue: number;
            numOfDelayDriver: number;
            numOfCriticalPath: number;
            numOfAssignedToMe: number;
        };
        itemProgramActivities: {
            title: string;
            matrixItemIndex: number;
            numOfItem: number;
            numOfOverdue: number;
            numOfDelayDriver: number;
            numOfCriticalPath: number;
            numOfAssignedToMe: number;
        };
    };
    prioritizeComponent: {
        title: string;
        itemRecommendation: {
            title: string;
            matrixItemIndex: number;
            numOfItem: number;
            numOfOverdue: number;
            numOfDelayDriver: number;
            numOfCriticalPath: number;
            numOfAssignedToMe: number;
        };
        itemUserActivities: {
            title: string;
            matrixItemIndex: number;
            numOfItem: number;
            numOfOverdue: number;
            numOfDelayDriver: number;
            numOfCriticalPath: number;
            numOfAssignedToMe: number;
        };
        itemProgramActivities: {
            title: string;
            matrixItemIndex: number;
            numOfItem: number;
            numOfOverdue: number;
            numOfDelayDriver: number;
            numOfCriticalPath: number;
            numOfAssignedToMe: number;
        };
    };
    laterComponent: {
        title: string;
        itemRecommendation: {
            title: string;
            matrixItemIndex: number;
            numOfItem: number;
            numOfOverdue: number;
            numOfDelayDriver: number;
            numOfCriticalPath: number;
            numOfAssignedToMe: number;
        };
        itemUserActivities: {
            title: string;
            matrixItemIndex: number;
            numOfItem: number;
            numOfOverdue: number;
            numOfDelayDriver: number;
            numOfCriticalPath: number;
            numOfAssignedToMe: number;
        };
        itemProgramActivities: {
            title: string;
            matrixItemIndex: number;
            numOfItem: number;
            numOfOverdue: number;
            numOfDelayDriver: number;
            numOfCriticalPath: number;
            numOfAssignedToMe: number;
        };
    };
    info: IToolTip;
}
